import 'bootstrap/dist/css/bootstrap.min.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './i18n/i18n'
import store from './store'
import TrezorConnect from 'trezor-connect'
import VueYoutubeEmbed from 'vue-youtube-embed'
import Clipboard from 'v-clipboard'

TrezorConnect.init({
  // connectSrc: 'https://localhost:8088/',
  lazyLoad: true, // this param will prevent iframe injection until TrezorConnect.method will be called
  manifest: {
    email: 'developer@xyz.com',
    appUrl: 'http://your.application.com'
  }
})

Vue.config.productionTip = false

Vue.use(VueYoutubeEmbed)
Vue.use(Clipboard)

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
